export default __webpack_public_path__ + "static/media/ognresultbanner.05100bc3.jpg";